import { useState, useEffect } from 'react';
import { Home } from 'lucide-react';
import logo from '../logo.png';
import { AuthPanel, useAuth } from './AuthModule';
import MailsArea from './MailsArea';
import CreditsArea from './CreditsArea';
import DiscordButton from './DiscordButton';

const FINNISH_MONTHS = [
  'tammikuuta', 'helmikuuta', 'maaliskuuta', 'huhtikuuta', 'toukokuuta', 'kesäkuuta',
  'heinäkuuta', 'elokuuta', 'syyskuuta', 'lokakuuta', 'marraskuuta', 'joulukuuta',
];

function formatClockLabel(now) {
  const hh = String(now.getHours()).padStart(2, '0');
  const mm = String(now.getMinutes()).padStart(2, '0');
  const day = now.getDate();
  const month = FINNISH_MONTHS[now.getMonth()];
  return `${hh}:${mm} ${day}. ${month}`;
}

function Clock() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const update = () => setNow(new Date());
    update();
    const interval = setInterval(update, 60000);
    return () => clearInterval(interval);
  }, []);

  const time = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
  const label = formatClockLabel(now);

  return (
    <a
      href="/"
      className="menu-clock"
      aria-label={label}
      title={label}
    >
      <Home className="menu-clock-home-icon" size={18} aria-hidden />
      <span>{time}</span>
    </a>
  );
}

function Menu() {
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useAuth();
  const ohjeetHighlight = Boolean(user?.firstTimer);

  const rawPath = typeof window !== 'undefined' ? window.location.pathname || '/' : '/';
  const path = rawPath.replace(/^\/+/, '/');
  const isBetaPath =
    path === '/beta-testaajaksi' ||
    path === '/beta-testaajaksi/' ||
    path.startsWith('/beta-testaajaksi/');

  return (
    <div className={`Menu${isBetaPath ? ' Menu--beta-landing' : ''}`}>
      <div className="logo-wrapper">
        {user && !isBetaPath && (
          <>
            <Clock className="menu-clock" />
            <MailsArea />
            <CreditsArea />
          </>
        )}
      </div>

      <a
        href={isBetaPath ? '/beta-testaajaksi' : '/'}
        className="Menu-logo"
        title={isBetaPath ? 'Pulina beta - etusivu' : 'Pulina - etusivu'}
      >
        <div className="Menu-logoInner">
          <span className="Menu-betaBadge">BETA</span>
          <img src={logo} alt="Pulina" />
        </div>
      </a>

      <button
        type="button"
        className="Hamburger"
        aria-label="Avaa valikko"
        aria-expanded={isOpen}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span />
        <span />
        <span />
      </button>

      <nav
        className={`Menu-links ${isOpen ? 'Menu-links--open' : ''}`}
        onClick={() => setIsOpen(false)}
      >
        {user && <DiscordButton />}
        {(isBetaPath || user) && (
          <a
            href={isBetaPath ? '/beta-testaajaksi/ohjeet' : '/ohjeet'}
            className={!isBetaPath && ohjeetHighlight ? 'Menu-link--highlight' : undefined}
          >
            Ohjeet
          </a>
        )}
        <a href={isBetaPath ? '/beta-testaajaksi/pulinasta' : '/pulinasta'}>Pulina?</a>

        {(!isBetaPath || user) && <AuthPanel />}
      </nav>
    </div>
  );
}

export default Menu;

